import React from 'react';
import { Form, Input, Button, Select } from 'antd';
import { EditOutlined , MailOutlined   } from '@ant-design/icons';
import { withTranslation } from "react-i18next";
import axios from 'axios';
import i18n from "../../utils/i18n";
import config from '../../utils/config';
import { openErrorMsg } from '../../utils/messageUtils';
import './index.css'


const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

class CarrierVer extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
          isSecond: true,
          paramData: null,
          isSucess: false,
        }
    }

  
    
    formRef = React.createRef()
    componentDidMount() {
      i18n.changeLanguage('en');
      localStorage.setItem('lang', 'en_US');
      setTimeout(() => {
        this.getDetail();
      }, 500);
    }

    getDetail = () =>{
      const params={
        path: window.location.href,
      }
      axios
      .post(`${config.API_HOST}/transport/v1/2/inquiry/quote/get-carrier-email`,params)
      .then((res) => {
          console.log('res--',res);
          if(res?.data && res.data.failed){
            openErrorMsg(
              this.props.t('tips', { defaultValue: '提示' }), 
              res.data.message
            );
            return;
          }
          if(res?.data){
            if(res.data?.boolVerified === 'Y'){
              this.props.history.push({
                pathname: `/carrierQuo`,
                search:`?inquiryId=${res?.data?.inquiryId}&carrierId=${res?.data?.carrierId}&transportRequireId=${res?.data?.transportRequireId}&uniqueKey=${res?.data?.uniqueKey}&carrierEmail=${res?.data?.carrierEmail}`
              });
            }else{
              this.setState({
                paramData: res.data,
                isSucess: true,
              });
              const data = res.data;
              delete data.lang;
              if (this.formRef.current) {
                this.formRef.current.setFieldsValue(data);
              }
            }
            
          }
      })
      .catch((err) => {
          console.log(err);
      });
    }

    getCaptcha = () =>{
      const params={
        path: window.location.href,
      }
      axios
      .post(`${config.API_HOST}/transport/v1/2/inquiry/quote/send-email-captcha`,params)
      .then((res) => {
          console.log('res--',res);
          this.handleCountDown(60);
      })
      .catch((err) => {
          console.log(err);
      });
    }

    handleCountDown = (seconds) => {
      let second = seconds;
      this.setState({isSecond: false, secondTime:second})
      const countDown = () => {
          if (second > 0) {
          second--;
          this.setState({ secondTime:second})
          }
          if (second === 0) {
          this.setState({isSecond: true})
          second = seconds;
          clearTimeout(second); // 清除计时器
          return;
          }
          setTimeout(countDown, 1000);
      };
      setTimeout(countDown, 1000);
    };

    onFinish = (values) =>{
      
      const params={
        path: window.location.href,
        captchaCode: values?.captcha,
        lang: values.lang,
      }
      console.log('param---',params);
      // if(true)return
      axios
      .post(`${config.API_HOST}/transport/v1/2/inquiry/quote/verification-captcha`,params)
      .then((res) => {
          console.log('res--',res);
          if(res?.data && res.data.failed){
            openErrorMsg(
              this.props.t('tips', { defaultValue: '提示' }), 
              res.data.message
            );
            return;
          }
          if(res?.data){
            this.props.history.push({
              pathname: `/carrierQuo`,
              search:`?inquiryId=${res?.data?.inquiryId}&carrierId=${res?.data?.carrierId}&transportRequireId=${res?.data?.transportRequireId}&uniqueKey=${res?.data?.uniqueKey}&carrierEmail=${res?.data?.carrierEmail}`
            });
          }
          
      })
      .catch((err) => {
          console.log(err);
      });
    }

    handleChange = (e) =>{
      i18n.changeLanguage(e);
      let type = e
      if(e === 'en_US'){
        type = 'en'
      }else if(e === 'en_ID'){
        type = 'ina'
      }else if(e === 'zh_CN'){
        type = 'zh'
      } 
      localStorage.setItem('languageType', type);
      localStorage.setItem('lang', e);
    }


    render() {
        const { paramData } = this.state
        console.log('data:',this.props.form);
        return (
        <div className='ver-div'>
          <div className='form-div'>
            <div className='form-body'>
              <Form
                  className='check-form'
                  {...layout}
                  name="basic"
                  size='large'
                  ref={this.formRef}
                  initialValues={{carrierEmail: paramData?.carrierEmail}}
                  onFinish={this.onFinish.bind(this)}
              >
                <Form.Item name="lang">
                  <Select
                    defaultValue="en_US"
                    // style={{ width: 120 }}
                    onChange={this.handleChange}
                    options={[
                      { value: 'zh_CN', label: '中文(CN)' },
                      { value: 'en_US', label: 'English' },
                      { value: 'en_ID', label: 'Indonesia' },
                      { value: 'fr_FR', label: 'Français'},
                      { value: 'es_ES', label: 'Español'},
                      { value: 'th_TH', label: 'ภาษาไท'},
                      { value: 'ru_RU', label: 'Русский'},
                      { value: 'ms_MS', label: 'Melayu'},
                      { value: 'pt_PT', label: 'Português'},
                      { value: 'vi_VI', label: 'Tiếng Việt'},
                      { value: 'ar_AR', label: 'اللغة العربية'},
                    ]}
                  />
                </Form.Item>
                <Form.Item name="carrierEmail" rules={[{ required: true, message: this.props.t('phonePlaceholder', { defaultValue: '请输入邮箱' }) }]}>
                  <Input disabled prefix={<MailOutlined  />} 
                  // onChange={this.phoneChange.bind(this)}  
                  />
                </Form.Item>

                <Form.Item name="captcha" rules={[{ required: true, message: this.props.t('captchaPlaceholder', { defaultValue: '请输入验证码' }) }]} >
                  <Input prefix={<EditOutlined />} placeholder={ this.props.t('captchaPlaceholder', { defaultValue: '请输入验证码' }) } suffix={
                  <Button type='link' disabled={!this.state.isSecond || !this.state.isSucess}  
                    onClick={this.getCaptcha.bind(this)}
                  >
                      {this.state.isSecond
                      ? this.props.t('getcCptcha', { defaultValue: '获取验证码' })
                      : `${this.state.secondTime}S`}</Button>
                  } />
                </Form.Item>

                <div>
                  <Form.Item className="button-form">
                      <Button disabled={!this.state.isSucess} type="primary" htmlType="submit" className="password-form-button">{ this.props.t('verify', { defaultValue: '验证' }) }</Button>
                  </Form.Item>
                </div>  
              </Form>
            </div>
           
          </div>
          
        </div>
        )
    }
}

export default CarrierVer = withTranslation()(CarrierVer);